import Swiper from "swiper"

// Debug flag to control logging
const DEBUG = false

// Wait for DOM to fully load
document.addEventListener("DOMContentLoaded", () => {
  let frameCheckInterval
  let frameAttempts = 0
  const maxFrameAttempts = 60 // Check for 30 seconds max (60 * 500ms)

  // Set up polling to look for the recommendation frame
  function checkForRecommendationFrame() {
    frameAttempts++

    // Check if the required div exists now
    const recommendationFrame = document.getElementById(
      "ylDynamicMostVisitedFrame",
    )

    if (recommendationFrame) {
      if (DEBUG)
        console.log(
          "[YL Customizer] Found ylDynamicMostVisitedFrame on attempt " +
            frameAttempts,
        )
      clearInterval(frameCheckInterval)
      // Initialize the main functionality once the frame is found
      initializeCustomizer()
    } else if (frameAttempts >= maxFrameAttempts) {
      if (DEBUG)
        console.info(
          "[YL Customizer] No ylDynamicMostVisitedFrame found after " +
            frameAttempts +
            " attempts. Exiting script.",
        )
      clearInterval(frameCheckInterval)
    }
  }

  // Start checking for the recommendation frame
  frameCheckInterval = setInterval(checkForRecommendationFrame, 500)

  // Main function to initialize the customizer once the frame is found
  function initializeCustomizer() {
    let checkInterval
    let attempts = 0
    const maxAttempts = 30 // Check for 15 seconds max (30 * 500ms)
    let alreadyProcessed = false // Flag to track if we've already processed

    // Function to check if content is loaded and process it
    function checkAndProcessFrames() {
      // If we've already processed, don't do it again
      if (alreadyProcessed) {
        return
      }

      attempts++
      if (DEBUG)
        console.log(`[YL Customizer] Check attempt ${attempts}/${maxAttempts}`)

      // Find the product elements with the new selector
      const productElements = document.querySelectorAll(
        ".ylRecommendationFrame__products__product",
      )

      if (productElements && productElements.length > 0) {
        if (DEBUG)
          console.log(
            `[YL Customizer] Found ${productElements.length} product elements, processing...`,
          )

        // Clear the interval since we found the elements
        clearInterval(checkInterval)

        // Process the products
        processProducts(productElements)

        // Set the flag to prevent reprocessing
        alreadyProcessed = true

        // Disconnect the observer as we don't need it anymore
        if (observer) {
          observer.disconnect()
          if (DEBUG)
            console.log(
              "[YL Customizer] Observer disconnected after successful processing",
            )
        }
      } else if (attempts >= maxAttempts) {
        if (DEBUG)
          console.log(
            "[YL Customizer] Reached maximum check attempts, stopping",
          )
        clearInterval(checkInterval)
      }
    }

    // Function to process products and create custom elements
    function processProducts(productElements) {
      // Limit to the first 4 products
      const limitedProductElements = Array.from(productElements).slice(0, 4)

      // Check if we already have a custom container (to prevent duplicates)
      const existingContainer = document.querySelector(".yl-custom-container")
      if (existingContainer) {
        if (DEBUG)
          console.log(
            "[YL Customizer] Custom container already exists, skipping processing",
          )
        return
      }

      // Find the original frame and hide it
      const originalFrame = document.getElementById("ylDynamicMostVisitedFrame")
      originalFrame.style.opacity = "0"
      originalFrame.style.height = "0"
      originalFrame.style.overflow = "hidden"
      originalFrame.style.pointerEvents = "none"
      originalFrame.style.position = "absolute"

      // Create a new container for custom elements with Swiper structure
      const customContainer = document.createElement("div")
      customContainer.className =
        "yl-custom-container yl-custom-swiper-container"

      // Add header and set text to "Najczęściej oglądane"
      const header = document.createElement("h2")
      header.className = "yl-custom-header"
      // Get translation from #localisation div
      const localisationDiv = document.getElementById("localisation")
      header.innerHTML =
        localisationDiv?.dataset?.mostVisited || "Najczęściej oglądane"
      customContainer.appendChild(header)

      // Create swiper wrapper
      const swiperWrapper = document.createElement("div")
      swiperWrapper.className = "yl-custom-swiper-wrapper"
      customContainer.appendChild(swiperWrapper)

      // Add pagination
      const pagination = document.createElement("div")
      pagination.className = "yl-custom-pagination"
      customContainer.appendChild(pagination)

      // Insert in our target div or after the original frame
      const targetDiv = document.querySelector("#popupframe")
      if (targetDiv) {
        if (DEBUG)
          console.log(
            "[YL Customizer] Inserting custom container into #popupframe",
          )
        targetDiv.appendChild(customContainer)
      } else if (originalFrame.parentNode) {
        if (DEBUG)
          console.log(
            "[YL Customizer] Inserting custom container after original frame",
          )
        // If #popupframe doesn't exist, insert after the original frame
        originalFrame.parentNode.insertBefore(
          customContainer,
          originalFrame.nextSibling,
        )
      } else {
        if (DEBUG)
          console.error(
            "[YL Customizer] No suitable target found for custom container",
          )
        return
      }
      if (DEBUG)
        console.log(
          "[YL Customizer] Custom container created and inserted into the DOM",
        )

      // Process each product element
      limitedProductElements.forEach((product, index) => {
        if (DEBUG)
          console.log(`[YL Customizer] Processing product ${index + 1}`)

        // Create slide for swiper
        const slideElement = document.createElement("div")
        slideElement.className = "yl-custom-slide"

        // Create new product wrapper
        const customProduct = document.createElement("div")
        customProduct.className = "yl-custom-product"
        customProduct.setAttribute("data-index", index) // Store index for click handler

        // Get the href attribute
        const linkUrl = product.getAttribute("href")
        if (linkUrl) {
          customProduct.setAttribute("data-href", linkUrl)

          // Add click event to trigger click on original element
          customProduct.addEventListener("click", (e) => {
            e.preventDefault()
            e.stopPropagation()

            // Create and dispatch a click event on the original element
            try {
              const clickEvent = new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                view: window,
              })
              product.dispatchEvent(clickEvent)
            } catch (error) {
              if (DEBUG)
                console.error("[YL Customizer] Error triggering click:", error)
              // Fallback: navigate to URL directly
              window.location.href = linkUrl
            }
          })
        }

        // Get image - Updated for new structure
        const imageEl = product.querySelector(
          ".ylRecommendationFrame__products__product__img",
        )
        if (imageEl) {
          const customImage = document.createElement("div")
          customImage.className = "yl-custom-image"
          customImage.style.backgroundImage = `url(${imageEl.src})`
          customImage.style.backgroundSize = "cover"
          customImage.style.backgroundPosition = "center"
          customImage.style.backgroundRepeat = "no-repeat"
          // Height and width are now controlled by CSS media queries
          customProduct.appendChild(customImage)
        }

        // Get title - Updated for new structure
        const titleEl = product.querySelector(
          ".ylRecommendationFrame__products__product__name",
        )
        if (titleEl) {
          const customTitle = document.createElement("h3")
          customTitle.className = "yl-custom-name"
          customTitle.innerHTML = titleEl.innerHTML
          customProduct.appendChild(customTitle)
        }

        // Get description - Updated for new structure
        const descriptionEl = product.querySelector(
          ".ylRecommendationFrame__products__product__info",
        )
        if (descriptionEl) {
          const customDescription = document.createElement("h4")
          customDescription.className = "yl-custom-description"
          customDescription.innerHTML = descriptionEl.innerHTML
          customProduct.appendChild(customDescription)
        }

        // Get features/icons - Updated for new structure
        const iconsContainer = product.querySelector(
          ".ylRecommendationFrame__products__product__icons",
        )
        if (iconsContainer) {
          const featuresContainer = document.createElement("div")
          featuresContainer.className = "yl-custom-features"

          // Use the ready-made icons directly
          const iconElements = iconsContainer.querySelectorAll(
            ".ylRecommendationFrame__products__product__icon",
          )
          if (iconElements.length > 0) {
            iconElements.forEach((iconImg) => {
              const featureIcon = document.createElement("div")
              featureIcon.className = "yl-custom-icon"

              // Extract icon name from src for the title tooltip
              const iconSrc = iconImg.src
              const iconName = iconSrc
                .split("/")
                .pop()
                .replace("icon_", "")
                .replace(".png", "")
                .replace(/_/g, " ")

              featureIcon.setAttribute("title", iconName)

              // Use the provided icon as background
              featureIcon.style.backgroundImage = `url(${iconImg.src})`
              featureIcon.style.backgroundSize = "contain"
              featureIcon.style.backgroundPosition = "center"
              featureIcon.style.backgroundRepeat = "no-repeat"

              featuresContainer.appendChild(featureIcon)
            })

            customProduct.appendChild(featuresContainer)
          }
        }

        // Add the product to the slide
        slideElement.appendChild(customProduct)

        // Add the slide to the wrapper
        swiperWrapper.appendChild(slideElement)
        if (DEBUG)
          console.log(
            `[YL Customizer] Added product ${index + 1} to custom container`,
          )
      })

      if (DEBUG)
        console.log(
          `[YL Customizer] Processed ${limitedProductElements.length} products successfully`,
        )

      // Initialize Swiper for mobile devices
      initializeSwiper()
    }

    // Function to initialize Swiper on mobile only
    function initializeSwiper() {
      // Check if Swiper is available
      if (typeof Swiper === "undefined") {
        if (DEBUG) console.error("[YL Customizer] Swiper is not available")
        return
      }

      setupResponsiveSwiper()
    }

    let mySwiper = null

    // Setup responsive Swiper that only activates on mobile
    function setupResponsiveSwiper() {
      // Make sure Swiper is loaded before proceeding
      if (typeof Swiper === "undefined") {
        setTimeout(setupResponsiveSwiper, 200)
        return
      }

      function initOrDestroySwiper() {
        const isMobile = window.innerWidth < 992

        if (isMobile) {
          if (!mySwiper) {
            if (DEBUG)
              console.log("[YL Customizer] Initializing Swiper for mobile")
            mySwiper = new Swiper(".yl-custom-swiper-container", {
              slidesPerView: "auto",
              spaceBetween: 42,
              pagination: {
                el: ".yl-custom-pagination",
                clickable: true,
                bulletClass: "yl-custom-pagination-bullet",
                bulletActiveClass: "yl-custom-pagination-bullet-active",
              },
              // Force slides to be their defined width
              slideToClickedSlide: true,
              watchSlidesProgress: true,
              slideClass: "yl-custom-slide",
              wrapperClass: "yl-custom-swiper-wrapper",
              updateOnWindowResize: true,
            })
          }
        } else {
          if (mySwiper) {
            if (DEBUG)
              console.log("[YL Customizer] Destroying Swiper for desktop")
            mySwiper.destroy(true, true)
            mySwiper = null
          }
        }
      }

      // Initialize on page load
      initOrDestroySwiper()

      // Reinitialize on window resize
      window.addEventListener("resize", () => {
        initOrDestroySwiper()
      })
    }

    // Start checking for content immediately and then every 500ms
    checkAndProcessFrames()
    checkInterval = setInterval(checkAndProcessFrames, 500)

    // Set up a MutationObserver to detect when new content is added
    const observer = new MutationObserver((mutations) => {
      // Skip if we've already processed
      if (alreadyProcessed) {
        return
      }

      // Check for mutations that add nodes
      const relevantMutations = mutations.filter(
        (mutation) => mutation.addedNodes && mutation.addedNodes.length > 0,
      )

      if (relevantMutations.length > 0) {
        if (DEBUG)
          console.log(
            "[YL Customizer] DOM changes detected, checking for product elements",
          )
        checkAndProcessFrames()
      }
    })

    // Observe the entire document with subtree option to catch deep changes
    observer.observe(document.body, { childList: true, subtree: true })
    if (DEBUG) console.log("[YL Customizer] Initialized observers")
  }
})
